import Slider from './src/slider'

export default Slider
